module.exports = __webpack_public_path__ + "static/media/turn14.52d3bad6.png";